// removed by extract-text-webpack-plugin
module.exports = {"container":"_3Vx4X","body":"_2Wn0J","title":"rzygy","benefits":"_3tVzm","list":"_3SJcu","checklist":"_3mF8y _3SJcu","checklist__item":"_14mtH","link":"_1yV7x","calculator":"_11UzW","calculator-link":"_1XQud _1yV7x"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/Fees.less
// module id = ./src/components/Home/Fees.less
// module chunks = 2